import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../feature/auth/AuthSlice";
import userReducer from "../feature/user/UserSlice";
import referralReducer from "../feature/referral/ReferralSlice";
import machineReducer from "../feature/machine/MachineSlice";
import stakeReducer from "../feature/stake/StakeSlice";
import minersOwnedReducer from "../feature/minersOwned/minersOwnedSlice";
import walletReducer from "../feature/wallet/WalletSlice";
import inviteReducer from "../feature/invite/InviteSlice";
import minerReducer from "../feature/minerEarning/MinerEarningSlice";
import depositReducer from "../feature/deposit/DepositSlice";
import historyReducer from "../feature/history/HistorySlice";
import notificationReducer from "../feature/notification/NotificationSlice";
import withdrawalReducer from "../feature/withdraw/withdrawSlice";
import messageReducer from "../feature/message/messageSlice";
import inputReducer from "../feature/inputError/inputErrorSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    user: userReducer,
    referral: referralReducer,
    machine: machineReducer,
    stake: stakeReducer,
    minersOwned: minersOwnedReducer,
    wallet: walletReducer,
    invite: inviteReducer,
    minerEarning: minerReducer,
    deposit: depositReducer,
    history: historyReducer,
    notification: notificationReducer,
    withdraw: withdrawalReducer,
    message: messageReducer,
    inputError: inputReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
